module.exports = __webpack_public_path__ + "static/media/1.5_manual.e425473c.png";